import axios, { AxiosResponse } from "axios";
import { axiosClient } from "../apiClient";
import { promises } from "dns";

// export function getDatesByTournamentId(tournament_id: number) {
//   return axiosClient.get(`/api/tournament/${tournament_id}/dates`);
// }

export async function getDatesByTournamentId(
  tournament_id: number
): Promise<AxiosResponse<Date[]>> {
  try {
    const response = await axiosClient.get(
      `/api/tournament/${tournament_id}/dates`
    );
    return response;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(
        `Failed to fetch dates by tournament ID ${tournament_id}: ${error.message}`
      );
    } else {
      throw new Error("An unnown error occurred in getDatesByTournamenrId");
    }
  }
}

export async function getMatchesByTouranamentIdandDate(
  tournament_id: number,
  date: string
): Promise<AxiosResponse<Date[]>> {
  //   return axiosClient.get(`/api/tournament/${tournament_id}/date/${date}`);
  try {
    const response = await axiosClient.get(
      `/api/tournament/${tournament_id}/date/${date}`
    );
    return response;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(
        `Failed to fetch dates by tournament ID ${tournament_id} and the date ${date}: ${error.message}`
      );
    } else {
      throw new Error(
        "An unknown error occurred in getMatchesByTournamentIdandDate"
      );
    }
  }
}


export async function getAllMatchesByTouranamentIdandDate(
  tournament_id: number,
  date: string
): Promise<AxiosResponse<Date[]>> {
  //   return axiosClient.get(`/api/tournament/${tournament_id}/date/${date}`);
  try {
    const response = await axiosClient.get(
      `/api/tournament/score/${tournament_id}/date/${date}`
    );
    return response;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(
        `Failed to fetch matches by tournament ID ${tournament_id} and the date ${date}: ${error.message}`
      );
    } else {
      throw new Error(
        "An unknown error occurred in getAllMatchesByTournamentIdandDate"
      );
    }
  }
}

export async function getAllMatchesForTypeTwo(
  tournament_id: number,
  date: string
): Promise<AxiosResponse<Date[]>> {
  //   return axiosClient.get(`/api/tournament/${tournament_id}/date/${date}`);
  try {
    const response = await axiosClient.get(
      `/api/tournament/typetwo/${tournament_id}/date/${date}`
    );
    return response;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(
        `Failed to fetch matches by tournament ID ${tournament_id} and the date ${date}: ${error.message}`
      );
    } else {
      throw new Error(
        "An unknown error occurred in getAllMatchesForTypeTwo"
      );
    }
  }
}

// export function getMatchesByCourt(court: string) {
//   return axiosClient.get(`/api/court/${court}/matches`);
// }

export async function getMatchesByCourt(court: string): Promise<AxiosResponse> {
  try {
    const response = await axiosClient.get(`/api/court/${court}/matches`);
    return response;
  } catch (error: unknown) {
    if (error instanceof Error) {
      throw new Error(
        `Failed to fetch matches by court ${court}: ${error.message}`
      );
    } else {
      throw new Error("An unnown error occured in getMatchesByCourt");
    }
  }
}

export async function getMatchesByCourtAndDate(
  court: string,
  date: string,
  tournament_id:number
): Promise<AxiosResponse> {
  try {
    const response = await axiosClient.get(`/api/court/${court}/date/${date}/id/${tournament_id}`);
    return response;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        `Failed to fetch matches by court ${court} and the date ${date}. Axios error: ${error.message}`
      );
    } else if (error instanceof Error) {
      throw new Error(
        `Failed to fetch matches by court ${court} and the date ${date}. Error: ${error.message}`
      );
    } else {
      throw new Error("An unknown error occurred in getMatchesByCourtAndDate");
    }
  }
}

export async function getMatcehsDetailsByMatchId(
  match_uuid: any,
  matchType:any
): Promise<AxiosResponse> {
  try {
    const response = await axiosClient.get(`/api/match/${match_uuid}/${matchType}`);
    return response;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        `Failed to fetch match details by ${match_uuid} . Axios error: ${error.message}`
      );
    } else if (error instanceof Error) {
      throw new Error(
        `Failed to fetch match details by ${match_uuid} . Error: ${error.message}`
      );
    } else {
      throw new Error(
        "An unknown error occurred in getMatchesDetailsByMatchId"
      );
    }
  }
}

export async function getTournamentIdByTournamentName(
  tournament_name: string
): Promise<AxiosResponse> {
  try {
    const response = await axiosClient.get(
      `/api/tournament/tournament_id/${tournament_name}`
    );
    return response;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        `Failed to fetch tournament id by ${tournament_name} . Axios error: ${error.message}`
      );
    } else if (error instanceof Error) {
      throw new Error(
        `Failed to fetch tournament id by ${tournament_name} . Error: ${error.message}`
      );
    } else {
      throw new Error(
        "An unknown error occurred in getTournamentIdByTournamentName"
      );
    }
  }
}

export async function getTournamentTypeById(
  tournament_id: number
): Promise<AxiosResponse> {
  try {
    const response = await axiosClient.get(
      `/api/tournament/tournament_type/${tournament_id}`
    );
    return response;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        `Failed to fetch tournament id by ${tournament_id} . Axios error: ${error.message}`
      );
    } else if (error instanceof Error) {
      throw new Error(
        `Failed to fetch tournament id by ${tournament_id} . Error: ${error.message}`
      );
    } else {
      throw new Error(
        "An unknown error occurred in getTournamentTypeById"
      );
    }
  }
}
export async function getBroadcastMessageByTournamentId(
  tournament_id: number
): Promise<AxiosResponse> {
  try {
    const response = await axiosClient.get(
      `/api/tournament/broadcast_message/${tournament_id}`
    );
    return response;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        `Failed to fetch tournament id by ${tournament_id} . Axios error: ${error.message}`
      );
    } else if (error instanceof Error) {
      throw new Error(
        `Failed to fetch tournament id by ${tournament_id} . Error: ${error.message}`
      );
    } else {
      throw new Error(
        "An unknown error occurred in getTournamentTypeById"
      );
    }
  }
}
export async function getTournamentSlugByOrganizerSlug(
  oranization_slug: string
): Promise<AxiosResponse> {
  try {
    const response = await axiosClient.get(
      `/api/tournament/tournament_slug/${oranization_slug}`
    );
    return response;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        `Failed to fetch tournament slug by ${oranization_slug} . Axios error: ${error.message}`
      );
    } else if (error instanceof Error) {
      throw new Error(
        `Failed to fetch tournament slug by ${oranization_slug} . Error: ${error.message}`
      );
    } else {
      throw new Error(
        "An unknown error occurred in getTournamentSlugByOrganizerSlug"
      );
    }
  }
}
export async function getSponsorLogoByTournamentId(
  tournament_id: number
): Promise<AxiosResponse> {
  try {
    const response = await axiosClient.get(
      `/api/tournament/logos/${tournament_id}`
    );
    return response;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        `Failed to fetch tournament id by ${tournament_id} . Axios error: ${error.message}`
      );
    } else if (error instanceof Error) {
      throw new Error(
        `Failed to fetch tournament id by ${tournament_id} . Error: ${error.message}`
      );
    } else {
      throw new Error(
        "An unknown error occurred in getSponsorLogoByTournamentId"
      );
    }
  }
}
// export async function checkOrganizationSlug(
//   organizer_slug: string
// ): Promise<AxiosResponse> {
//   try {
//     const response = await axiosClient.get(
//       `/api/tournament/check/${organizer_slug}`
//     );
//     return response;
//   } catch (error: unknown) {
//     if (axios.isAxiosError(error)) {
//       throw new Error(
//         `Failed to fetch tournament slug by ${organizer_slug} . Axios error: ${error.message}`
//       );
//     } else if (error instanceof Error) {
//       throw new Error(
//         `Failed to fetch tournament slug by ${organizer_slug} . Error: ${error.message}`
//       );
//     } else {
//       throw new Error(
//         "An unknown error occurred in checkOrganizationSlug"
//       );
//     }
//   }
// }
// import axios, { AxiosResponse } from "axios";
// import { axiosClient } from "../apiClient";

// export async function getDatesByTournamentId(
//   tournament_id: number
// ): Promise<AxiosResponse<Date[]>> {
//   try {
//     const response = await axiosClient.get(`/api/tournament/${tournament_id}/dates`);
//     return response;
//   } catch (error) {
//     throw new Error(`Failed to fetch dates by tournament ID ${tournament_id}: ${error.message}`);
//   }
// }

// export async function getMatchesByTouranamentIdandDate(
//   tournament_id: number,
//   date: string
// ): Promise<AxiosResponse<Match[]>> {
//   try {
//     const response = await axiosClient.get(`/api/tournament/${tournament_id}/date/${date}`);
//     return response;
//   } catch (error) {
//     throw new Error(`Failed to fetch matches by tournament ID ${tournament_id} and date ${date}: ${error.message}`);
//   }
// }

// export async function getMatchesByCourt(
//   court: string
// ): Promise<AxiosResponse<Match[]>> {
//   try {
//     const response = await axiosClient.get(`/api/court/${court}/matches`);
//     return response;
//   } catch (error) {
//     throw new Error(`Failed to fetch matches by court ${court}: ${error.message}`);
//   }
// }
